import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";
import type { CreatePayloadContext } from "@/components/tables/genericCrudTable.createPayload";
import type { UpdatePayloadContext } from "@/components/tables/genericCrudTable.updatePayload";

const withCompanyContext = (
  result: any,
  values: any,
  ctx: CreatePayloadContext | UpdatePayloadContext
) =>
  ctx.selectedChildCompanySubjectId || ctx.companySubjectId
    ? {
        ...values,
        company_subject: ctx.companySubjectId,
        impersonate_subject: ctx.selectedChildCompanySubjectId
          ? ctx.selectedChildCompanySubjectId
          : ctx.companySubjectId,
      }
    : result;

export const departmentEntityAdapter: EntityAdapter = {
  entity: "department",
  adjustCreatePayload: withCompanyContext,
  adjustUpdatePayload: withCompanyContext,
  defaultSort: { sort: "id", tableSort: "id", descending: false },
};
